<template>
    <div :class="$style['popup-result']">
        <div v-if="isSuccess" class="popup-result__content">
            <div v-if="phone" :class="[$style['popup-result__title'], 'h2']">Звонок заказан</div>
            <div v-if="email" :class="[$style['popup-result__title'], 'h2']">Отправлено</div>

            <div v-if="phone" :class="$style['popup-result__text']">
                Менеджер перезвонит вам по&nbsp;номеру <span class="nobr">{{ phone }}</span>.
                В&nbsp;будние дни до&nbsp;18:00 заявка обрабатывается в&nbsp;течение двух часов.
                По&nbsp;выходным&nbsp;&mdash; в&nbsp;течение суток.
            </div>

            <div :class="$style['popup-result__icon']">
                <svg width="160" height="160" viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path opacity="0.5" fill-rule="evenodd" clip-rule="evenodd" d="M1 80C1 123.63 36.3695 159 80 159C123.63 159 159 123.63 159 80C159 36.3695 123.63 1 80 1C36.3695 1 1 36.3695 1 80ZM80 0C35.8172 0 0 35.8172 0 80C0 124.183 35.8172 160 80 160C124.183 160 160 124.183 160 80C160 35.8172 124.183 0 80 0Z" fill="#B98F4F"></path>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M123.106 54.7087L69.9974 107.41L39.293 76.706L40.7072 75.2918L70.0028 104.587L121.697 53.2891L123.106 54.7087Z" fill="#B98F4F"></path>
                </svg>
            </div>
        </div>

        <div v-if="isError" class="popup-result__content">
            <div :class="[$style['popup-result__title'], 'h2']">Ошибка</div>
            <div :class="$style['popup-result__text']">
                <div v-if="errorMessage">{{ errorMessage }}</div>
                <div v-else>Попробуйте заполнить форму позднее</div>
            </div>
            <div :class="$style['popup-result__icon']">
                <svg width="160" height="160" viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path opacity="0.3" fill-rule="evenodd" clip-rule="evenodd" d="M1 80C1 123.63 36.3695 159 80 159C123.63 159 159 123.63 159 80C159 36.3695 123.63 1 80 1C36.3695 1 1 36.3695 1 80ZM80 0C35.8172 0 0 35.8172 0 80C0 124.183 35.8172 160 80 160C124.183 160 160 124.183 160 80C160 35.8172 124.183 0 80 0Z" fill="#EB5757"></path>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M79.9931 81.6126L54.7033 106.709L53.2945 105.289L78.5843 80.193L53.2891 54.7024L54.7087 53.2936L80.004 78.7842L105.696 53.2891L107.105 54.7087L81.4127 80.2038L106.709 105.695L105.289 107.104L79.9931 81.6126Z" fill="#EB5757"></path>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['isSuccess', 'isError', 'phone', 'email', 'errorMessage']
    }
</script>

<style lang="scss" module>
    @import "./PopupResult";
</style>
